export const EMAIL_ADDRESS_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const sanitizePhoneNumberInput = (value = "") => {
  const cleaned = value.replace(/[^\d+\s()-]/g, "");
  const hasLeadingPlus = cleaned.trim().startsWith("+");
  const withoutExtraPlus = cleaned.replace(/\+/g, "");
  return hasLeadingPlus ? `+${withoutExtraPlus}` : withoutExtraPlus;
};

export const normalizePhoneNumber = (value = "") => {
  const trimmed = value.trim();
  let normalized = trimmed.replace(/[^\d+]/g, "");
  if (normalized.startsWith("00")) {
    normalized = `+${normalized.slice(2)}`;
  }
  if (normalized.startsWith("+")) {
    normalized = `+${normalized.slice(1).replace(/\+/g, "")}`;
  } else {
    normalized = normalized.replace(/\+/g, "");
  }
  return normalized;
};

export const validatePhoneNumber = (value = "") => {
  const normalized = normalizePhoneNumber(value);
  const digits = normalized.startsWith("+") ? normalized.slice(1) : normalized;

  if (!digits) {
    return "Phone number is required.";
  }

  if (!/^\d+$/.test(digits) || digits.length < 7 || digits.length > 15) {
    return "Enter a valid phone number using 7 to 15 digits.";
  }

  return "";
};

export const normalizeEmailAddress = (value = "") => value.trim().toLowerCase();

export const validateOptionalEmailAddress = (value = "") => {
  const normalized = normalizeEmailAddress(value);
  if (!normalized) {
    return "";
  }
  if (!EMAIL_ADDRESS_PATTERN.test(normalized)) {
    return "Enter a valid email address.";
  }
  return "";
};
